"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketMessagePrinter = void 0;
var SupportedAdaptiveCards_1 = require("./interfaces/SupportedAdaptiveCards");
var utilities_1 = require("../utilities");
var WebSocketMessagePrinter = /** @class */ (function () {
    function WebSocketMessagePrinter() {
    }
    WebSocketMessagePrinter.printify = function (event) {
        var _a, _b, _c;
        var result = {};
        if (event) {
            result.id = event.id;
            result.tags = ((_a = event === null || event === void 0 ? void 0 : event.metadata) === null || _a === void 0 ? void 0 : _a.tags) ? event.metadata.tags.replace(/"/g, "").split(",").filter(function (tag) { return tag.length > 0; }) : [];
            result.bot = ((_c = (_b = event === null || event === void 0 ? void 0 : event.metadata) === null || _b === void 0 ? void 0 : _b.tags) === null || _c === void 0 ? void 0 : _c.includes('public')) ? false : true;
            result.card = Object.values(SupportedAdaptiveCards_1.SupportedAdaptiveCards).some(function (type) { var _a; return (_a = event === null || event === void 0 ? void 0 : event.message) === null || _a === void 0 ? void 0 : _a.includes(type); });
            if (!result.card && (event === null || event === void 0 ? void 0 : event.message)) {
                result.content = (0, utilities_1.messageContentMetadata)(event === null || event === void 0 ? void 0 : event.message);
            }
            result.created = event.createdOn;
        }
        return result;
    };
    return WebSocketMessagePrinter;
}());
exports.WebSocketMessagePrinter = WebSocketMessagePrinter;
//# sourceMappingURL=WebsocketMessagePrinter.js.map